export const cities = ['HQ Gliwice', 'Warszawa', 'Wrocław'];
export const categories = [
  'Product',
  'Technology',
  'Marketing',
  'HR',
  'Operations',
];
